import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { getLocalidades, deleteLocalidad } from "../helpers/rutaLocalidades";
import ModalLocalidad from "./ModalLocalidad";
import "../css/tableclientes.css";

const TableLocalidades = () => {
  const [localidades, setLocalidades] = useState({
    data: { localidades: [] },
    loading: true,
    error: "",
  });

  const [localidadSeleccionada, setLocalidadSeleccionada] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaLocalidades();
  }, []);

  const consultaLocalidades = async () => {
    try {
      const datos = await getLocalidades();
      setLocalidades({ data: datos || { localidades: [] }, loading: false, error: "" });
    } catch (e) {
      setLocalidades(s => ({ ...s, loading: false, error: e?.message || "Error al cargar localidades" }));
      console.error("❌ getLocalidades:", e);
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaLocalidades();
  };
  const handleShow = () => setShow(true);

  const modificaLocalidad = (localidad) => {
    setLocalidadSeleccionada(localidad); // ← pasamos el objeto directo
    handleShow();
  };

  const eliminarLocalidad = (id) => {
    if (window.confirm("¿Está seguro que desea borrar la localidad?")) {
      deleteLocalidad(id).then(() => consultaLocalidades());
    }
  };

  if (localidades.loading) return <div className="p-3">Cargando localidades…</div>;
  if (localidades.error)   return <div className="p-3 text-danger">{localidades.error}</div>;

  // ---- ORDEN: Localidad (A→Z), y segundo criterio Provincia
  const rows = (localidades.data?.localidades || [])
    .filter(l => l?.activo ?? true)
    .sort((a, b) => {
      const A = a?.localidad?.toString().trim() || "";
      const B = b?.localidad?.toString().trim() || "";
      if (!A && !B) return 0;
      if (!A) return 1;       // los vacíos al final
      if (!B) return -1;
      const cmpLoc = A.localeCompare(B, "es", { sensitivity: "base" });
      if (cmpLoc !== 0) return cmpLoc;
      const PA = a?.provincia?.provincia || "";
      const PB = b?.provincia?.provincia || "";
      return PA.localeCompare(PB, "es", { sensitivity: "base" });
    });

  return (
    <div className="table-container">
      <div className="col-12 mt-4"></div>
      <Table striped bordered hover>
        <thead>
          <tr className="header">
            <th className="borrar">Acciones</th>
            <th>Localidad</th>
            <th>Código Postal</th>
            <th>Provincia</th>
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td colSpan={4} className="text-center">No hay localidades.</td></tr>
          ) : (
            rows.map((localidad) => (
              <tr key={localidad._id}>
                <td className="borrar" style={{ whiteSpace: "nowrap" }}>
                  <div className="d-flex align-items-center justify-content-center gap-2 flex-nowrap">
                    <button className="btn btn-primary" onClick={() => modificaLocalidad(localidad)}>
                      <i className="fa fa-pencil-square-o" />
                    </button>
                    <button className="btn btn-danger" onClick={() => eliminarLocalidad(localidad._id)}>
                      <i className="fa fa-trash-o" />
                    </button>
                  </div>
                </td>
                <td>{localidad.localidad || "-"}</td>
                <td>{localidad.codigopostal || "-"}</td>
                <td>{localidad.provincia?.provincia || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      <ModalLocalidad
        show={show}
        handleClose={handleClose}
        localidad={localidadSeleccionada}
      />
    </div>
  );
};

export default TableLocalidades;
